export default __webpack_public_path__ + "static/media/mui.6b886ee2.png";